import useTableColumnBizProp from '../components/useTableColumnBizProp.jsx'
import Model from './ModelBd.mjs'

export const useTableColumnBdName = () => useTableColumnBizProp(
    {Model, prop: 'bdName'}
)

export const useTableColumnBdNo = () => useTableColumnBizProp(
    {Model, prop: 'bdNo'}
)
